import { useFacilityMode } from '@/entities/facility';
import { FacilityFloorPlanTable } from '@/entities/floor-plan';
import type { FC } from 'react';

type FacilityFloorPlanTabProps = {
  /** Omit for the portfolio view — beds across every accessible facility. */
  facilityId?: string;
};

export const FacilityFloorPlanTab: FC<FacilityFloorPlanTabProps> = ({
  facilityId,
}) => {
  const { facilitiesOptions } = useFacilityMode();

  const isPortfolioMode = facilityId === undefined;

  if (!isPortfolioMode) {
    return <FacilityFloorPlanTable facilityId={+facilityId} />;
  }

  // The Facility filter lives inside the table's own filter panel, next to
  // Status and Floor, rather than floating above it.
  return <FacilityFloorPlanTable facilitiesOptions={facilitiesOptions ?? []} />;
};
